import { Grid, Row, Col } from 'rsuite'
import { splitEvery } from 'ramda'
import pubhubData from '@/utils/apiHelpers/pubhubData'
import LinkButton from '@/components/shared/linkButton'
import useModelAlias from '@/hooks/useModelAlias'
import { sortNames } from '@/utils/marketingModelNames'
import useTranslation from '@/hooks/useTranslation'
import { useCallback } from 'react'
import { useRouter } from 'next/router'
import { showWarning } from '@/components/shared/toaster'

const getNextPageInFlow = (uniqueProductsGroupedByModel, brand, model) => {
  const query = { brand, model, modelType: '', ngtdModelId: '' }
  const hasSingleModelType = uniqueProductsGroupedByModel[model].length === 1
  const result = {
    page: 'modelTypes',
    query,
    error: null
  }
  if (hasSingleModelType) {
    result.page = 'languages'
    const { modelType: _modelType, ngtdModelId } = uniqueProductsGroupedByModel[model][0]
    result.query.modelType = _modelType
    if (ngtdModelId) {
      result.query.ngtdModelId = ngtdModelId
      result.page = 'generations'
    } else {
      result.error = 'not_possible_to_obtain_generation'
    }
  }
  return result
}

const ChooseVehicle = ({ i18nL10n, products, modelLangMarketingNames }) => {
  const router = useRouter()
  const t = useTranslation()
  const {
    all,
    filterBy: { brand }
  } = products
  const { locale } = i18nL10n
  const uniqueProductsGroupedByModel = pubhubData.getUniqueProductsGroupedByModel(
    all.filter(p => p.brand?.toLowerCase() === brand?.toLowerCase())
  )
  const sortedModelNames = sortNames(modelLangMarketingNames.model, Object.keys(uniqueProductsGroupedByModel), locale)
  const getModelAlias = useModelAlias(modelLangMarketingNames, locale)

  const selectProduct = useCallback(
    (groups, brand, model) => {
      const { page, query, error } = getNextPageInFlow(groups, brand, model)
      if (error) {
        // Can still navigate to the next page, but show an error
        showWarning(t(error))
      }
      router.push(`/${page}?${new URLSearchParams(query).toString()}`)
    },
    [router, t]
  )

  return (
    <>
      <h4 className="mb-10 mr-20 choose-vehicle">{t('homepage_choose_vehicle')}</h4>
      <Grid fluid>
        {splitEvery(4, sortedModelNames).map((row, i) => (
          <Row key={i}>
            {row.map((model, y) => (
              <Col key={y} xs={24} sm={6}>
                <LinkButton
                  size="lg"
                  appearance="link"
                  onClick={() => selectProduct(uniqueProductsGroupedByModel, brand, model)}
                  className="pointer"
                >
                  {getModelAlias(model, 'model')}
                </LinkButton>
              </Col>
            ))}
          </Row>
        ))}
      </Grid>
    </>
  )
}

export default ChooseVehicle
